import { PackageSizeItem } from "@shared/algolia/results/components/ResultComponents/hit-types";

interface Props {
  packageSizesList: PackageSizeItem[];
  currentPackageSizePZN: number;
  changePackageSize: (item: PackageSizeItem) => void;
}

export const ProductPackageSizes = (props: Props) => {
  return (
    <div
      className="product-card__package-sizes"
      role="radiogroup"
      aria-label="Packungsgröße wählen"
    >
      {props.packageSizesList.map((packageSizeItem) => {
        return (
          <button
            type="button"
            role="radio"
            aria-checked={
              Number(props.currentPackageSizePZN) === Number(packageSizeItem.pzn)
            }
            key={packageSizeItem.pzn}
            className={`alternative-package-size ${
              Number(props.currentPackageSizePZN) === Number(packageSizeItem.pzn) && "active"
            }`}
            onClick={() => {
              props.changePackageSize(packageSizeItem);
            }}
          >
            {packageSizeItem.amount_unit.trim() !== "" && packageSizeItem.amount_unit.trim()}
            {packageSizeItem.amount_unit.trim() === "" && <span>X St.</span>}
          </button>
        );
      })}
    </div>
  );
};
